import React from "react";
import { GridCellKind, measureTextCached } from "@glideapps/glide-data-grid";
import "../../../icons/Icon.js";
import { customIconCharacterMapping } from "../../../icons/types.js";
import "../../../icons/ExpandMoreIcon.js";
import { GlideCell } from "./GlideCell.js";
class GlideButtonCell extends GlideCell {
  _cellKind = "button";
  constructor(valueGetter) {
    super(valueGetter, "");
  }
  getRenderer(muiTheme) {
    const paddingField = muiTheme.custom.button.padding;
    const padding = typeof paddingField === "string" ? Number.parseInt(paddingField) : paddingField;
    const iconFont = "1em icomoon";
    const fontSizeProperty = muiTheme.typography.body1.fontSize;
    const fontSize = typeof fontSizeProperty === "string" ? Number.parseInt(fontSizeProperty) : fontSizeProperty;
    const textFont = `${fontSize ?? 14}px ${muiTheme.typography.fontFamily ?? "Inter, Arial"}`;
    function drawTitleWithIcon(ctx, cellBounds, drawArea, value, textColor, iconColor) {
      const y = cellBounds.y + drawArea.y + drawArea.height / 2;
      let x = cellBounds.x + drawArea.x + padding;
      const text = value?.title;
      const icon = customIconCharacterMapping[value?.icon?.key];
      const drawText = (content, font, color) => {
        if (!content) {
          return;
        }
        ctx.fillStyle = color;
        ctx.font = font;
        ctx.fillText(content, x, y);
        x += measureTextCached(content, ctx).width;
        if (icon) {
          x += padding / 2;
        }
      };
      const iconFirst = value?.icon?.position === "start";
      if (iconFirst) {
        drawText(icon, iconFont, iconColor);
        drawText(text, textFont, textColor);
      } else {
        drawText(text, textFont, textColor);
        drawText(icon, iconFont, iconColor);
      }
    }
    function drawIcon(ctx, cellBounds, drawArea, value, iconColor) {
      const iconValue = customIconCharacterMapping[value?.icon?.key];
      ctx.font = iconFont;
      ctx.fillStyle = iconColor;
      const { width } = measureTextCached(iconValue ?? "", ctx);
      const x = cellBounds.x + drawArea.x + (drawArea.width - width) / 2;
      const y = cellBounds.y + drawArea.y + drawArea.height / 2;
      ctx.fillText(iconValue ?? "", x, y);
    }
    function getRectangleWithButton(ctx, title, iconKey, rect, padding2) {
      const height = 32;
      let width = 32;
      if (title) {
        const icon = customIconCharacterMapping[iconKey];
        if (icon) {
          ctx.font = iconFont;
          const iconMetric = measureTextCached(icon, ctx);
          ctx.font = textFont;
          const textMetric = title ? measureTextCached(title, ctx) : null;
          width = (textMetric?.width ?? 0) + (iconMetric?.width ?? 0) + padding2 * 2.5;
        } else {
          ctx.font = textFont;
          const textMetric = title ? measureTextCached(title, ctx) : null;
          width = (textMetric?.width ?? 0) + padding2 * 2;
        }
      }
      return { x: (rect.width - width) / 2, y: (rect.height - height) / 2, width, height };
    }
    return {
      kind: GridCellKind.Custom,
      isMatch: (cell) => cell.data.kind === this._cellKind,
      needsHover: true,
      needsHoverPosition: true,
      draw: (args, cell) => {
        const { ctx, rect, hoverX, hoverY, overrideCursor } = args;
        let textColor = muiTheme.palette.text.primary;
        let borderColor = muiTheme.custom.palette.content.liner;
        let iconColor = muiTheme.palette.text.primary;
        const value = cell.data.value;
        const buttonRect = getRectangleWithButton(ctx, value?.title, value?.icon?.key, rect, padding);
        if (hoverX >= buttonRect.x && hoverX <= buttonRect.x + buttonRect.width && hoverY >= buttonRect.y && hoverY <= buttonRect.y + buttonRect.height && !cell.data.value?.disabled) {
          overrideCursor("pointer");
          textColor = muiTheme.palette.primary.main;
          borderColor = muiTheme.palette.primary.main;
        }
        if (value?.icon?.color) {
          iconColor = muiTheme.custom.palette.status[value.icon.color]?.main;
        }
        if (cell.data.value?.disabled) {
          textColor = muiTheme.palette.secondary.main;
          iconColor = muiTheme.palette.secondary.main;
        }
        if (value?.title) {
          drawTitleWithIcon(ctx, rect, buttonRect, value, textColor, iconColor);
        } else {
          drawIcon(ctx, rect, buttonRect, value, iconColor);
        }
        ctx.strokeStyle = borderColor;
        ctx.beginPath();
        ctx.roundRect(
          rect.x + buttonRect.x,
          rect.y + buttonRect.y,
          buttonRect.width,
          buttonRect.height,
          value?.variant === "circle" ? buttonRect.width / 2 : muiTheme.custom.roundedButtonRadius
        );
        ctx.stroke();
      },
      onClick: (args) => {
        const { cell, bounds, posX, posY } = args;
        let result = void 0;
        const value = cell.data.value;
        if ((value?.title || value?.icon?.key) && value?.onClick && !value?.disabled) {
          const canvas = document.createElement("canvas");
          const ctx = canvas.getContext("2d", { alpha: false });
          const rect = getRectangleWithButton(ctx, value?.title, value?.icon?.key, bounds, padding);
          const isLinkClicked = posX >= rect.x && posX <= rect.x + rect.width && posY >= rect.y && posY <= rect.y + rect.height;
          if (isLinkClicked) {
            value.onClick();
            result = cell;
          }
        }
        return result;
      }
    };
  }
  getCustomContent(value) {
    return {
      kind: GridCellKind.Custom,
      copyData: value?.title,
      data: {
        kind: this._cellKind,
        value,
        tooltip: TextCellTooltipContent
      },
      allowOverlay: false
    };
  }
  formatValue(value) {
    return value;
  }
  isCellEmpty(value, isSummary) {
    return isSummary || !value?.title && !value?.icon || !value?.onClick;
  }
}
function TextCellTooltipContent({ value }) {
  return /* @__PURE__ */ React.createElement("div", null, value?.tooltip ?? value?.title);
}
export {
  GlideButtonCell
};
//# sourceMappingURL=GlideButtonCell.js.map
